import script from "./PricingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PricingPage.vue?vue&type=script&setup=true&lang=ts"

import "./PricingPage.vue?vue&type=style&index=0&id=9f8be806&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f8be806"]])

export default __exports__